<script>
import DOMPurify from 'dompurify';
import ContentBlockView from '@shared/mixins/ContentBlockView';

export default {
  mixins: [ContentBlockView],
  data: () => ({ isFlipped: false }),
  computed: {
    questionHtml() {
      return DOMPurify.sanitize(this.getFormattedText(this.data.question));
    },
    answerHtml() {
      return DOMPurify.sanitize(this.getFormattedText(this.data.answer));
    },
  },
  i18n: {
    messages: {
      en: {
        flashcard: {
          flip_card: 'Flip card',
        },
      },
      fr: {
        flashcard: {
          flip_card: 'Retourner la carte',
        },
      },
    },
  },
};
</script>

<template>
  <div class="compf_scene">
    <div class="compf_card" :class="{ 'is_flipped': isFlipped }">
      <div class="compf_face compf_front">
        <div class="box px-10 py-20 flex-center-center w-full h-full">
          <div
            class="content"
            :style="{ textAlign: data.question_alignment }"
            v-html="questionHtml"
          />
        </div>
      </div>
      <div class="compf_face compf_back">
        <div class="box px-10 py-20 flex-center-center w-full h-full">
          <div
            class="content"
            v-html="answerHtml"
          />
        </div>
      </div>
    </div>
    <b-tooltip
      class="is-absolute"
      style="bottom: 12px; right: 12px;"
      position="is-left"
    >
      <template #content>
        <span v-t="'flashcard.flip_card'" />
      </template>
      <b-button
        type="is-text"
        class="is-custom"
        icon-right="sync"
        @click="isFlipped = !isFlipped"
      />
    </b-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.compf_scene {
  position: relative;
  perspective: 1000px;
}

.compf_card {
  display: grid;
  width: 100%;
  transform-style: preserve-3d;
  transition: transform 0.6s;

  &.is_flipped {
    transform: rotateY(180deg);
  }
}

.compf_face {
  grid-area: 1 / 1 / 2 / 2;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden; /* Safari */
}

.compf_back {
  transform: rotateY(180deg);
}
</style>
